import React, { lazy } from "react";

import { useFaces, useGlobalLoading, usePageUpdated, useFacebook } from "hooks";
import useFilestackView from "hooks/useFilestackView";
import LoadingModal from "components/LoadingModal";

const FaceUploadModal = lazy(() => import("components/FaceUploadModal"));
const PageUpdatedModal = lazy(() => import("components/PageUpdatedModal"));
const PickerOverlay = lazy(() => import("components/FaceUploadModal/components/PickerOverlay/PickerOverlay"));

const RenderModal = () => {
  const { modalOpened } = useFaces();
  const { isPending, labelFunc, progress } = useGlobalLoading();
  const { GetHandleView: handleView } = useFilestackView();
  const { isUpdating } = usePageUpdated(true);
  const { modalOpen: facebookModalOpen } = useFacebook();

  return (
    <>
      {(modalOpened || facebookModalOpen) && <FaceUploadModal />}
      {isUpdating && <PageUpdatedModal />}
      {handleView && <PickerOverlay />}
      {isPending && <LoadingModal labelFunc={labelFunc} progress={progress} />}
    </>
  );
};

export default RenderModal;
